import { calcSpacing } from 'src/components/foundations';
import styled from 'styled-components';

export const CardHeaderStyled = styled.div<{
  hasDivider: boolean;
}>`
  padding: ${calcSpacing(2)}px;
  padding-bottom: ${({ hasDivider }) =>
    hasDivider ? `${calcSpacing(2)}px` : '0'};
  position: relative;
`;

export const CardHeaderDividerContainerStyled = styled.div`
  position: absolute;
  right: ${calcSpacing(2)}px;
  bottom: 0;
  left: ${calcSpacing(2)}px;
`;
